//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AngleA",1,0],[0,"AngleB",1,0],[0,"AngleString",1,1],[0,"GeometryGroup",1,"CAM.InspectionGroup",0],[0,"ProbeTipType",1,0],[0,"ProgramGroup",1,"CAM.InspectionGroup",0],[0,"ProgramLocationString",1,0],[1,"SelectFeatures",0,"SelectNXObjectList",0],[0,"SensorGroup",1,"CAM.InspectionGroup",0],[0,"SensorOpName",1,0],[0,"SensorStrategy",1,0],[0,"Setup",1,"CAM.InspectionSetup",0],[0,"TipAngleMode",1,0],[0,"TipMode",1,0],[0,"TipNumber",1,0],[0,"TipString",1,1],[0,"ToolGroup",1,"CAM.InspectionGroup",0],[0,"ToolString",1,0],[0,"TypeName",1,0]],[[["nFeatures"],"GetSelectedFeatures",{R_:{selectedFeatures:""}},0,0],[["selectedFeatures"],"SetSelectedFeatures",{},1,0],[[],"CreatePaths",{},0,0],[["nTags"],"GetFeatureMethods",{R_:{featureMethods:"CAM.InspectionGroup[]"}},0,0],[["featureMethods"],"SetFeatureMethods",{},1,0]],[]];
SPLM.CAM.InspectionCreatePathsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InspectionCreatePathsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;